// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav--3hieL","scale-up":"scale-up--2quDv","top":"top--SJPxZ"};